import { useProfileFetch } from "./useProfileFetch";
import { useProfileSave } from "./useProfileSave";
import type { ProfileData } from "@/types/profile";

export const useProfileData = () => {
  const { profile, setProfile, loading } = useProfileFetch();
  const { saving, saveProfile } = useProfileSave();

  return {
    profile,
    setProfile,
    loading,
    saving,
    saveProfile,
  };
};

export type { ProfileData };